;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"3ff966d48242c624caa4bb305b0889ac7b52dcf1"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "16.2.4";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/production";globalThis["_sentryAssetPrefix"] = "https://assets-v2.i-scmp.com/production";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from "@sentry/nextjs";

import { config } from "shared/data";
import { sentryConfig, sentryIgnoreStackTraceFiles } from "shared/lib/sentry/config";
import { supportedBrowsers } from "shared/lib/sentry/supported-browsers";

const integrations = [
  Sentry.captureConsoleIntegration({ levels: ["error"] }),
  Sentry.contextLinesIntegration(),
  Sentry.extraErrorDataIntegration({ depth: 6 }),
  Sentry.graphqlClientIntegration({
    endpoints: [/\/content-delivery\/v2$/, /\/user-service\/v1$/],
  }),
  Sentry.httpClientIntegration(),
];

if (config.sentry.enableTracing) {
  integrations.push(
    Sentry.browserTracingIntegration({
      enableInp: false,
      enableLongAnimationFrame: false,
      enableReportPageLoaded: false,
    }),
  );
}

Sentry.init({
  ...sentryConfig,
  beforeSend: event => {
    if (
      typeof navigator === "undefined" || // not browser environment
      !supportedBrowsers.test(navigator.userAgent) || // not supported browsers
      !event.user // not logged in
    ) {
      return null;
    }

    // check ignored stack trace files
    const ignoredStackTrace = (event.exception?.values ?? []).some(exception =>
      (exception.stacktrace?.frames ?? []).some(frame =>
        sentryIgnoreStackTraceFiles.some(ignoreCheck => {
          if (!frame.filename) return false;
          if (typeof ignoreCheck === "string") return frame.filename.includes(ignoreCheck);
          return ignoreCheck.test(frame.filename);
        }),
      ),
    );
    if (ignoredStackTrace) return null;

    return event;
  },
  integrations,
  replaysOnErrorSampleRate: config.sentry.enableTracing ? 1 : 0,
  replaysSessionSampleRate: config.sentry.enableTracing ? 0.01 : 0,
  sampleRate: 0.25,
  tracesSampleRate: config.sentry.enableTracing ? 0.01 : 0,
  transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
